import { Drawer as MuiDrawer, DrawerProps as MuiDrawerProps, styled } from '@mui/material'
import { drawerWidth } from 'constants/layout'

interface DrawerProps extends MuiDrawerProps {
  isOpen?: boolean
}

export const Menu = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'isOpen' })<DrawerProps>(
  ({ theme, isOpen }) => ({
    '& .MuiDrawer-paper': {
      zIndex: theme.zIndex.drawer - 2,
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!isOpen && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
)
